/* eslint-disable @typescript-eslint/no-unused-vars,no-unused-vars */
import { createModel, RematchDispatch } from '@rematch/core';
import { message } from 'antd';
import produce from 'immer';
import { FILE_NAME_TYPE, MEDIA_TYPE } from '../../commons/constants/constants';
import { addIcons, removeIcons } from '../../services/iconSet.service';
import { uploadFiles } from '../../services/uploader.service';
import { IconSetData } from '../../types/IconSetData';
import { storeName as entityStore } from '../entities/iconSet.entity';
import { RootModel } from '../models';

export const storeName = 'iconSets';

const initialState = {
  editId: null,
  loading: false,
};

export const iconSet: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,

  reducers: {
    setEditId: produce((state, payload) => {
      state.editId = payload;
    }),
    setLoading: produce((state, payload) => {
      state.loading = payload;
    }),
  },
  effects: (dispatch: RematchDispatch<typeof iconSet>) => ({
    async loadDefaultIconSet(payload, state) {
      this.setLoading(true);
      const data = await dispatch[entityStore].getDefaultSet();
      if (data) {
        this.setEditId(data.id);
      }

      this.setLoading(false);
      return data;
    },
    async addIcons(payload, state) {
      const { editId = null } = state[storeName];
      this.setLoading(true);
      const { user } = state.user;
      try {
        const { files, category, imageStrip, frameWidth, frameHeight, shared = false } = payload;
        const fileRest = await uploadFiles(null, files, FILE_NAME_TYPE.ICON, user.id, 'media');
        const { filesList } = fileRest;
        const iconDtos = filesList.map(({ id, url, name }) => {
          return {
            name,
            shared,
            type: MEDIA_TYPE.ICON,
            file: { id, url },
            tags: [category],
            imageStrip,
            frameWidth,
            frameHeight,
          };
        });

        const request: IconSetData = {
          id: editId,
          icons: iconDtos,
          shared,
        };

        await addIcons(request);
        message.success('Icon library updated');
        return true;
      } catch (err) {
        message.error(`Fail to update icon library : ${err.message}`);
        console.error(err.message);
        return false;
      } finally {
        this.setLoading(false);
      }
    },
    async removeIcons(payload, state) {
      const { editId = null } = state[storeName];
      this.setLoading(true);
      const { user } = state.user;
      try {
        const { icons, category } = payload;
        const request: IconSetData = {
          id: editId,
          icons,
        };
        await removeIcons(request);
        message.warn('Icon has been deleted');
        return true;
      } catch (err) {
        message.error(`Fail to delete icon: ${err.message}`);
        console.error(err.message);
        return false;
      } finally {
        this.setLoading(false);
      }
    },
  }),
});

export default iconSet;
